class XTab extends HTMLSpanElement {
  constructor (self) {
    self = super(self)
    return self
  }
}

export default XTab
